/* globals elkitorg_config */

import { node_observable_component } from 'common/util/ComponentDecorator';
import './dolyame-page.scss';

@node_observable_component
export default class CartPage {
	static classname = 'dolyame-page';

	constructor($page) {
		this.$page = $page;

		this.initEventListeners();
	}

	initEventListeners = () => {
		$(document).ready(function(){
			$('.dolyame-faq__item').click(function(){
				$(this).find('.dolyame-faq__item-arrow').toggleClass('dolyame-faq__item-arrow_opened');
				$(this).find('.dolyame-faq__item-answer').slideToggle(300);
				return false;
			});
		});
	};
};
